import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "pageTitle": "Indeterminate Checkbox API",
  "title": "Indeterminate Checkbox",
  "props": ["IndeterminateCheckboxProps"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const Link = makeShortcode("Link");
const IndeterminateCheckboxProps = makeShortcode("IndeterminateCheckboxProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageContent componentName="indeterminate_checkbox" type="api" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  The IndeterminateCheckbox component is similar to the{' '}
  <Link to="/api/checkboxes" mdxType="Link">Checkbox component</Link>, except that instead of
  accepting a boolean <inlineCode>checked</inlineCode> value, it takes the
  `status` prop, with three possible statuses: `indeterminate`, `checked` and
  `unchecked`. The default status is `unchecked`.
      </LeadParagraph>
      <h2>{`Basic Usage`}</h2>
      <p>{`The `}<inlineCode parentName="p">{`status`}</inlineCode>{` is used to represent the state of a group of checkboxes that goes underneath it.`}</p>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`checked`}</inlineCode>{` means all of the checkboxes in the group are checked.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`indeterminate`}</inlineCode>{` means that some, but not all, checkboxes in the group are checked.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`unchecked`}</inlineCode>{` means that none of the checkboxes in the group are checked.`}</li>
      </ul>
      <p>{`The `}<inlineCode parentName="p">{`indeterminate`}</inlineCode>{` status cannot be changed by direct user action, it can only be changed by updating the prop.`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-tsx"
        }}>{`import React from 'react';

import {
  Checkbox,
  FormGroup,
  IndeterminateCheckbox,
  IndeterminateCheckboxStatus,
  magma,
} from 'react-magma-dom';

export function Example() {
  const [checkedItems, setCheckedItems] = React.useState<Array<boolean>>([
    true,
    false,
  ]);

  const status: IndeterminateCheckboxStatus = checkedItems.every(Boolean)
    ? IndeterminateCheckboxStatus.checked
    : checkedItems.some(Boolean)
      ? IndeterminateCheckboxStatus.indeterminate
      : IndeterminateCheckboxStatus.unchecked;

  function handleUpdateIndeterminateChecked(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    setCheckedItems([event.target.checked, event.target.checked]);
  }

  function handleUpdateRedChecked(event: React.ChangeEvent<HTMLInputElement>) {
    setCheckedItems([event.target.checked, checkedItems[1]]);
  }

  function handleUpdateBlueChecked(event: React.ChangeEvent<HTMLInputElement>) {
    setCheckedItems([checkedItems[0], event.target.checked]);
  }

  return (
    <FormGroup labelText="Categories">
      <IndeterminateCheckbox
        onChange={handleUpdateIndeterminateChecked}
        status={status}
        labelText="Colors"
      />
      <div style={{ marginLeft: magma.spaceScale.spacing08 }}>
        <Checkbox
          checked={checkedItems[0]}
          onChange={handleUpdateRedChecked}
          labelText="Red"
        />
        <Checkbox
          checked={checkedItems[1]}
          onChange={handleUpdateBlueChecked}
          labelText="Blue"
        />
      </div>
    </FormGroup>
  );
}
`}</code></pre>
      <h2>{`Inverse`}</h2>
      <pre><code parentName="pre" {...{
          "className": "language-tsx"
        }}>{`import React from 'react';

import {
  IndeterminateCheckbox,
  IndeterminateCheckboxStatus,
  Card,
  CardBody,
} from 'react-magma-dom';

export function Example() {
  return (
    <Card isInverse>
      <CardBody>
        <IndeterminateCheckbox
          status={IndeterminateCheckboxStatus.indeterminate}
          labelText="Colors"
          isInverse
        />
      </CardBody>
    </Card>
  );
}
`}</code></pre>
      <h2>{`Indeterminate Checkbox Props`}</h2>
      <p><strong parentName="p">{`Any other props supplied will be provided to the `}<inlineCode parentName="strong">{`Checkbox`}</inlineCode>{` Component, except for the `}<inlineCode parentName="strong">{`checked`}</inlineCode>{` prop.`}</strong></p>
      <IndeterminateCheckboxProps mdxType="IndeterminateCheckboxProps" />
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      